import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * IT Glue — Custom API key (Password Access). Shared: Add Integration modal + onboarding ITGlueSetupForm.
 * Grep: ITGlue API key instructions, Settings Admin API Keys
 */
export const ITGlueApiKeyGuideSteps: React.FC<{
  /** Extra sx for the ordered list (modal vs onboarding). */
  listSx?: object;
  title?: string;
  /** When false, omit the in-body title (parent already has a heading). */
  showTitle?: boolean;
}> = ({ listSx, title = "API key", showTitle = true }) => (
  <>
    {showTitle ? (
    <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1.5 }}>
      {title}
    </Typography>
    ) : null}
    <Box
      component="ol"
      sx={{
        m: 0,
        pl: 2.5,
        "& li": { mb: 0.75, fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 },
        ...listSx,
      }}
    >
      <Typography component="li">
        In IT Glue: <strong>Settings</strong> → <strong>Admin</strong> → <strong>API Keys</strong>.
      </Typography>
      <Typography component="li">
        Under <strong>Custom API Keys</strong>, click <strong>+</strong>.
      </Typography>
      <Typography component="li">
        Select <strong>Password Access</strong>.
      </Typography>
      <Typography component="li">
        Enter a <strong>Name</strong> for the API key.
      </Typography>
    </Box>
  </>
);

